var exports = {
  "OK": "ResultsHeader__Vct7D1",
  "rT": "ResultsHeading__WXAzrF",
  "c$": "ResultsTime__R4y09z",
  "q7": "Notices__FzzUlg",
  "dK": "Pagination__NEg4GG",
};

module.exports = exports;
